// removed by extract-text-webpack-plugin
module.exports = {"nodeContainer":"InXfF5xAmvmzBMfb-b2Lc","nodeName":"khNEFgSb-MRr-cyS1Pcie","icon":"nsmEBDt40w1P1UqKuDeAr"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupPage/GrantTree/TreeNode.pcss
// module id = 1413
// module chunks = 0